import { IState, FRIENDS_REFERRAL_SHOW_REWARDS_IMAGE_LIGHTBOX } from '../../modules/friends-referral';

import {
    END_OF_OPERATION,
    ERROR_GENERAL,
    INVITATION_PAGE,
    INVITEE_PAGE,
    INVITEE_PAGE_SOFT_CLOSING,
    PLATFORM_REGISTRATION,
    REFERRAL_DASHBOARD,
    REFERRAL_DASHBOARD_SOFT_CLOSING
} from '../../states/states.constants';
import { PLATFORM_TYPES } from '@sitegen/common/constants/platforms';
import { SWITCH_PREVIEW_STATE_HOST, SwitchPreviewStateAction } from '@sitegen/common/types/root-actions';
import { showRewardsImageLightbox } from '../../modules/friends-referral/friends-referral-store';

const initial: IState = {
    loading: false,
    error: null,
    platformsEligibility: null,
    invitationInfo: {
        platformId: PLATFORM_TYPES.PC,
        username: ''
    },
    campaignInfo: {
        name: '',
        endDate: null,
        softCloseMode: false,
        spaces: {},
        conversion: {
            conjunction: 1,
            rules: []
        },
        platformLock: true,
        crossPlatform: false
    },
    playerInfo: {
        isReferrer: false,
        invitationId: '',
        referrerUbiAccountId: '',
        referrerId: 7327,
        isConverted: false,
        platformId: PLATFORM_TYPES.PC
    },
    playerStats: null,
    rewardsImageLightboxOpened: false,
};

const mockData = {
    invitationInfo: {
        username: 'FakeFriend',
        platformId: PLATFORM_TYPES.PC,
    },
    campaignInfo: {
        name: 'FakeCampaign',
        endDate: '2022-12-02T14:26:46.748Z',
        softCloseMode: false,
        spaces: { [PLATFORM_TYPES.PC]: '60859c37-949d-49e2-8fc8-6d8dc40f1a9e' },
        platformLock: true,
        conversion: {
            conjunction: 1,
            rules: [{
                id: 'ruleID',
                paramThreshold: 2,
                paramName: 'test.name',
                paramThresholdOp: 3,
                type: 1
            }]
        },
        crossPlatform: true
    }
};

type Actions = SwitchPreviewStateAction | ReturnType<typeof showRewardsImageLightbox>;

/** Preview values for multiple variants of "Success" */
const friendsReferral = (state: IState = initial, action: Actions): IState => {
    switch (action.type) {
    case FRIENDS_REFERRAL_SHOW_REWARDS_IMAGE_LIGHTBOX:
        return { ...state, rewardsImageLightboxOpened: action.payload };
    case SWITCH_PREVIEW_STATE_HOST:
        switch (action.payload) {
        case PLATFORM_REGISTRATION:
            return {
                ...state,
                platformsEligibility: {
                    [PLATFORM_TYPES.PC]: true,
                    [PLATFORM_TYPES.PS4]: true,
                    [PLATFORM_TYPES.XONE]: true,
                },
            };
        case REFERRAL_DASHBOARD:
        case INVITEE_PAGE:
            return {
                ...state,
                ...mockData,
                playerStats: {
                    fakeStat: {
                        platform: 'PC',
                        value: '2'
                    },
                },
                playerInfo: {
                    referrerId: 666,
                    isConverted: false,
                    isReferrer: true
                }
            };
        case INVITEE_PAGE_SOFT_CLOSING:
        case REFERRAL_DASHBOARD_SOFT_CLOSING:
            return {
                ...state,
                ...mockData,
                campaignInfo: {
                    ...mockData.campaignInfo,
                    softCloseMode: true
                },
                playerStats: {
                    fakeStat: {
                        platform: 'PC',
                        value: '2'
                    },
                },
                playerInfo: {
                    referrerId: 666,
                    isConverted: false,
                    isReferrer: true
                }
            };
        case INVITATION_PAGE:
            return {
                ...state,
                ...mockData
            };
        case ERROR_GENERAL:
            return {
                ...state,
            };
        case END_OF_OPERATION:
            return {
                ...state,
                campaignInfo: {
                    platformLock: true,
                    name: 'FakeCampaign',
                    softCloseMode: false,
                    endDate: '2020-11-19T17:00:24.184Z',
                    spaces: { [PLATFORM_TYPES.PC]: '60859c37-949d-49e2-8fc8-6d8dc40f1a9e' },
                    conversion: {
                        conjunction: 1,
                        rules: []
                    },
                    crossPlatform: true
                },
            };
        default:
            return state;
        }
    default:
        return state;
    }
};

export default friendsReferral;
